import { createApp, reactive } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import HomePostCollection from '../pages/HomePostCollection.vue';

import PostItem from '../components/PostItem.vue';

class HomePostComponent {
  constructor({ container, postFeed, postCollection }) {
    this.app = null;
    this.container = container;
    this.postFeed = postFeed;
    this.postCollection = postCollection;
  }

  // Initialize the component
  init() {
    const props = { postFeed: this.postFeed, postCollection: this.postCollection }
    this.app = createApp(HomePostCollection, props);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });
    
    this.app.component('post-item', PostItem);

    // 不直接掛載到 this.container：容器裡還裝著 SSR 卡片，Vue mount() 會清空掛載目標，
    // 造成 SSR 卡片整批消失、換成骨架畫面，等 API 回來才重畫（見票 08）。改成在容器裡
    // 另外建一個空節點來掛載，SSR 卡片留在原地，直到元件內部資料到位才由元件自己移除
    // 舊內容（見 HomePostCollection.vue 的 replaceSsrContent）。
    // container 是 DOM 節點，不是選擇器字串（唯一呼叫點 app/views/home/home.html.erb 直接傳節點）。
    const mountNode = document.createElement('div');
    this.container.appendChild(mountNode);
    this.app.mount(mountNode);
  }
}

export default HomePostComponent;